import { render, staticRenderFns } from "./Patients.vue?vue&type=template&id=46e0c2c5&scoped=true&"
import script from "./Patients.vue?vue&type=script&lang=js&"
export * from "./Patients.vue?vue&type=script&lang=js&"
import style0 from "./Patients.vue?vue&type=style&index=0&id=46e0c2c5&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "46e0c2c5",
  null
  
)

export default component.exports